module.exports = __webpack_public_path__ + "media/images/help_correction_2-1c4033df32bb944faccb3099671e9dc3.png";